export const enum ButtonColor {
   WHITE = "white",
   ORANGE = "orange",
   RED = "red",
   BLUE = "blue",
}

export const enum ButtonSize {
   LARGE = "large",
   MEDIUM = "normal",
   NORMAL = "normal",
   SMALL = "small",
}
